module.exports = __webpack_public_path__ + "static/media/blurred_suits_bg.43e07ed6.png";